import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppComponent } from 'src/app/app.component';
import { BannerService } from 'src/app/service/bannerService.service';
import { Utils } from 'src/app/util/utils';
import { BannerWowGo } from './banner';

@Component({
  selector: 'app-banner-form',
  templateUrl: './banner-form.component.html',
  styleUrls: ['./banner-shared.scss'],
})
export class BannerFormComponent implements OnInit {

  formulario: FormGroup;
  carregando = false;
  nomeArquivo = '';
  contentType = '';
  documentType = '';
  dataFileBase64 = '';
  bannerBase64: string | ArrayBuffer | null = null;

  constructor(
    private formBuilder: FormBuilder,
    private bannerService: BannerService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
    private appComponent: AppComponent,
    private util: Utils,
  ) { }

  ngOnInit(): void {
    this.montarFormulario();
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.carregar(+id);
    }
  }

  montarFormulario() {
    this.formulario = this.formBuilder.group({
      id: [null, Validators.nullValidator],
      descricao: ['', Validators.required],
      dataInicio: ['', Validators.required],
      dataTermino: ['', Validators.required],
      url: ['', Validators.nullValidator],
      ativo: [true, Validators.required],
      imagem: ['', Validators.nullValidator],
    });
  }

  carregar(id: number) {
    this.carregando = true;
    this.appComponent.mostrarLoading();
    this.bannerService.consultarPorId(id).subscribe(response => {
      this.formulario.patchValue({
        id,
        descricao: response.descricao,
        ativo: response.ativo,
        dataInicio: this.util.formatarDateTimeParaNewDate(response.dataInicio),
        dataTermino: this.util.formatarDateTimeParaNewDate(response.dataTermino),
        url: response.url,
      });
      this.nomeArquivo = response.nomeArquivo;
      this.dataFileBase64 = response.dataFileBase64;
      this.bannerBase64 = response.dataFileBase64;
      this.carregando = false;
    }, () => {
      this.carregando = false;
      this.snackBar.open('Banner não encontrado.', 'ERRO', { duration: 2500 });
      this.voltarConsulta();
    }).add(() => this.appComponent.fecharLoading());
  }

  salvar() {
    if (this.formulario.invalid) {
      return;
    }
    this.appComponent.mostrarLoading();
    const formValues = this.formulario.value;
    const banner = new BannerWowGo(
      formValues.id,
      formValues.descricao,
      formValues.url,
      formValues.ativo,
      this.nomeArquivo,
      this.contentType,
      this.documentType,
      this.dataFileBase64,
      this.util.formatarData(formValues.dataInicio) ?? Date.toString(),
      this.util.formatarData(formValues.dataTermino) ?? Date.toString(),
    );

    const request = formValues.id
      ? this.bannerService.alterar(banner)
      : this.bannerService.salvar(banner);

    request.subscribe(() => {
      this.snackBar.open('Banner salvo com sucesso!', 'Sucesso', { duration: 2000 });
      this.voltarConsulta();
    }, errorResponse => {
      this.snackBar.open(errorResponse.error?.message ?? 'Erro ao salvar banner.', 'ERRO', { duration: 2000 });
    }).add(() => this.appComponent.fecharLoading());
  }

  async anexarArquivo(event: Event, tipoDocumento: string): Promise<void> {
    const files = (event.target as HTMLInputElement).files;
    if (!files) {
      return;
    }
    for (let i = 0; i < files.length; i++) {
      const arquivoBase64 = await this.util.getFileToBase64(files[i], tipoDocumento);
      this.contentType = arquivoBase64.contentType;
      this.dataFileBase64 = arquivoBase64.data;
      this.documentType = arquivoBase64.documentType;
      this.nomeArquivo = arquivoBase64.filename;
      this.bannerBase64 = arquivoBase64.data;
    }
  }

  limpar() {
    this.router.navigate(['/banner/form']);
    this.montarFormulario();
    this.nomeArquivo = '';
    this.contentType = '';
    this.documentType = '';
    this.dataFileBase64 = '';
    this.bannerBase64 = null;
  }

  voltarConsulta() {
    this.router.navigate(['/banner/consulta']);
  }
}
